module.exports = "query GroupsQuery($offset: Int!, $limit: Int!) {\n  groups(offset: $offset, limit: $limit) {\n    ...GroupFragment\n  }\n}\n"